import React, { Component, useState } from 'react';
import Nav from '../components/Nav';
import { database, auth, storage } from '../firebase';
var randomstring = require("randomstring");

class Profile extends Component {
constructor(props) {
    super(props);
    this.database = database.ref().child('users');
    this.user = auth.currentUser;
    this.state = {
      uid: "",

      name: "",
      bio: "",
      pass: "",

      file: null,
      file_banner: null
    }

    this.Save = this.Save.bind(this);
    this.updateUser = this.updateUser.bind(this);
}

componentDidMount() {
  auth.onAuthStateChanged(function(user) {
    if (user === null) window.location.pathname = "/giris-yap";
  });

  var a = "";
  auth.onAuthStateChanged(function(user) {
    a = user.uid;
    var array = [];
    database.ref("users/" + a).on(`value`, snap => {
      array.push(snap.val())

      if (array[0].banner) {
        if (array[0].banner == 1) document.getElementById("banner").style.background = `url(https://png.pngtree.com/thumb_back/fh260/background/20190223/ourmid/pngtree-pure-color-watercolor-graffiti-gradient-background-board-design-board-design-image_66713.jpg)`;
        else if (array[0].banner == 2) document.getElementById("banner").style.background = `url(http://www.pngmagic.com/product_images/rain-background-banner-min.jpg)`;
        else if (array[0].banner == 3) document.getElementById("banner").style.background = `url(https://img.wallpapersafari.com/desktop/1024/576/16/8/6oStix.png)`;
        else if (array[0].banner == 4) document.getElementById("banner").style.background = `url(https://validatedlearning.co/wp-content/uploads/2017/08/green-geo-background-banner.jpeg)`;
        else document.getElementById("banner").style.background = `url(${array[0].banner})`;

        document.getElementById("banner").style.backgroundSize = `cover`;
        document.getElementById("banner").style.backgroundPosition = `center`;
      } else document.getElementById("banner").style.background = "url(/sss-banner.jpg) center center / cover";

      document.getElementById("p_photo").src = array[0].userImage || "/default_user.jpg";
      document.getElementById("p_name").value = array[0].userName || "Error";
      document.getElementById("p_bio").value = array[0].bio || "";
      document.getElementById("pass").value = array[0].password || "Error";
    })
  });
  this.setState({uid: a})
}

onFileUpload = async () => {
  var file = this.state.file;

  if (file) {
    if (file.size > 5 * 1024 * 1024) {
      alert("Dosya boyutu maksimum 5MB olmalıdır.");
      return; // Exit the function if the file is too large
    }
    if (!file.type.startsWith("image/") || file.type === "image/gif") {
      alert("Desteklenmeyen bir dosya türü seçildi.");
      return; // Exit the function if the file type is not supported
    }

    document.getElementById("overlay").style.display = "block";
    document.getElementById("overlay-img").style.display = "block";
    var storaged = storage.ref("profile-photos");
    await storaged.child(`${auth.currentUser.uid}`).put(file)
    await storaged.child(`${auth.currentUser.uid}`).getDownloadURL().then(function(url) {
      //console.log(url)
      database.ref('users/'+auth.currentUser.uid).update({
        userImage: url,
      });
    })
  }
};

onBannerUpload = async () => {
  var file = this.state.file_banner;

  if (file) {
    if (file.size > 5 * 1024 * 1024) {
      alert("Dosya boyutu maksimum 5MB olmalıdır.");
      return; // Exit the function if the file is too large
    }
    if (!file.type.startsWith("image/") || file.type === "image/gif") {
      alert("Desteklenmeyen bir dosya türü seçildi.");
      return; // Exit the function if the file type is not supported
    }
    
    document.getElementById("overlay").style.display = "block";
    document.getElementById("overlay-img").style.display = "block";
    var storaged = storage.ref("banner-photos");
    await storaged.child(`${auth.currentUser.uid}`).put(file)
    await storaged.child(`${auth.currentUser.uid}`).getDownloadURL().then(function(url) {
      database.ref('users/'+auth.currentUser.uid).update({
        banner: url,
      });
    })
  }
};

async updateUser(user) {
  if (this.state.pass !== "") auth.currentUser.updatePassword(this.state.pass);
  await database.ref('users/'+auth.currentUser.uid).update({
    //userImage: user.userPhoto,
    userName: user.userName,
    bio: user.bio,
    //password: user.password,
  });
}

async Save() {
  await this.onFileUpload();
  await this.onBannerUpload();

  var data = {
    //userPhoto: document.getElementById("p_photo").src,
    userName: document.getElementById("p_name").value,
    bio: document.getElementById("p_bio").value,
    password: document.getElementById("pass").value,
  }

  if (data.userName == "") data.userName = document.getElementById("p_name").value;
  //if (data.userName == "") data.userName = document.getElementById("p_name").value;
  
  await this.updateUser(data)
  this.setState({
    name: "",
  });

  window.location.pathname = "/profil";
}
  render() {
    //function calcHeight(value) {
    //  let numberOfLineBreaks = (value.match(/\n/g) || []).length;
    //  console.log(numberOfLineBreaks)
    //  let newHeight = 20 + numberOfLineBreaks * 40 + 16 + 2;
    //  //(fazladan boşluk) + satırSayısı * ? + fontSize + ?
    //  return newHeight;
    //}
    //
    //let textarea = document.querySelector("textarea");
    //if (textarea) textarea.click();
    //if (textarea) textarea.addEventListener("click", () => {
    //  textarea.style.height = calcHeight(textarea.value) + "px";
    //});

    return (
      <>
        <Nav activeItem="profile"/>
        <div className="main">
          <div className="overlay" id="overlay"></div>
          <img src="/loading.svg" className="overlay-img" id="overlay-img"/>
          <p style={{fontSize: "30px", marginBottom: "10px", display: "none"}}>Profili Düzenle</p>

          <div className="banner" id="banner"></div>
          <label htmlFor="banner_image" style={{maxWidth: "200px"}}>
            <div className="banner-overlay"></div>
            <div className='banner-c'>
              <div style={{display: "inline-block", margin: "0 auto", marginTop: "90px"}}>Arkaplanı Değiştir</div>
            </div>
          </label>

          <div className="card">
            <div className="p_photo-div">
              <img id="p_photo" src="/default_user.jpg" alt="Profil Görseli" className='card-image'/>
              <label htmlFor="p_image" style={{maxWidth: "200px"}}>
                <div className="card-image-overlay"></div>
                <div className='card-image-c'>
                  <div style={{display: "inline-block", margin: "0 auto", marginTop: "60px"}}>Profil Fotoğrafını Değiştir</div>
                </div>
              </label>
            </div>

            <div>
              <input id="p_name" type="text" placeholder="Kullanıcı Adı" className="p_name" maxLength="20" autoComplete="off" onChange={event => this.setState({name: event.target.value})}/>
              <textarea rows='1' id="p_bio" type="text" placeholder="Biyografi" autoComplete="off" onChange={event => this.setState({bio: event.target.value})}/>
              <input id="pass" type="password" placeholder="Şifre" style={{display: "none"}} onChange={event => this.setState({pass: event.target.value})}/>
            </div>
            <div className="edit" onClick={this.Save}>
              <img src="/save.png" style={{width: "30px", height: "30px"}}/>
              <a style={{lineHeight: "28px"}}></a>
            </div>
          </div>
          <input type="file" id="p_image" className="profile-image" onChange={e => {document.getElementById('p_photo').src = window.URL.createObjectURL(e.target.files[0])
          this.setState({file: e.target.files[0]})}}/>
          <input type="file" id="banner_image" className="profile-image" onChange={e => {document.getElementById('banner').style.background = `url(${window.URL.createObjectURL(e.target.files[0])}) center center / cover`;
          document.getElementById('banner').style.backgroundPosition = `center`;
          this.setState({file_banner: e.target.files[0]})}}/>
        </div>
        <style>{`
          html {
            background: #F57029;
          }

          .overlay {
            top: 0;
            left: 0;
            background: #000;
            position: fixed;
            width: 100%;
            height: 100%;
            opacity: 0.7;
            z-index: 888;
            display: none;
          }

          .overlay-img {
            top: 50%;
            left: 50%;
            width: 150px;
            height: 150px;
            position: fixed;
            margin-top: -75px;
            margin-left: -75px;
            z-index: 899;
            display: none;
          }
          
          .main {
            width: 100%;
            margin: 0 auto;
            margin-top: 48px;
            padding: 0;
          }

          .banner {
            width: 100%;
            height: 200px;
            margin-bottom: -5px;
            object-fit: cover;
            background: #f0651a;
          }

          .banner-c {
            position: relative;
            margin-top: -200px;
            height: 203px;
            object-fit: cover;
            box-shadow: inset 0 0 350px 100px #000;
            color: #fff;
            opacity: 0;
            text-align: center;
            transition: .2s;
          }

          .banner-c:hover {
            opacity: 1.0;
          }
          
          .banner-c:hover .banner-overlay {
            opacity: 1.0;
          }

          .banner-overlay {
            position: relative;
            margin: auto;
            margin-top: -153px;
            border-radius: 500px;
            width: 100%;
            max-width: 200px;
            height: 150px;
            background-color: #000;
            opacity: 0;
            color: #fff;
          }

          .card {
            width: max-content;
            color: #fff;
            border-radius: 3px;
            padding: 25px 0;
            background: #F57029;
            margin: 0 auto;
            margin-top: 20px;
            display: flex;
          }

          .card-image {
            position: relative;
            margin: auto;
            border-radius: 500px;
            max-width: 200px;
            height: 200px;
            object-fit: cover;
            background-color: #fff;
          }
    
          .card-image-c {
            position: relative;
            margin: auto;
            margin-top: -150px;
            border-radius: 500px;
            max-width: 150px;
            height: 150px;
            object-fit: cover;
            box-shadow: inset 0 0 150px 20px #000;
            opacity: 0;
            color: #fff;
            text-align: center;
            transition: .2s;
          }

          .card-image-c:hover {
            opacity: 1.0;
          }
          
          .card-image-c:hover .card-image-overlay {
            opacity: 1.0;
          }

          .card-image-overlay {
            position: relative;
            margin: auto;
            margin-top: -153px;
            border-radius: 500px;
            width: 100%;
            max-width: 200px;
            height: 150px;
            background-color: #000;
            opacity: 0;
            color: #fff;
          }
    
          .card-text {
            max-width: 500px;
            margin: 0 auto;
            margin-bottom: 50px;
          }
    
          input {
            color: #fff;
            padding-left: 15px;
            border: 0;
            width: 300px;
            height: 40px;
            outline: none;
            background: none;
          }

          textarea {  
            overflow: hidden auto;
            width: 100%;
            max-width: 500px;
            height: 50vh;
            border: 0;
            margin: 0 auto;
            padding: 5px 0;
            padding-left: 15px;
            resize: none;
            outline: none;
            background: none;
            color: #fff;
            font-size: 16px;
          }
          
          textarea::-webkit-scrollbar {
            width: 10px;
            cursor: default;
          }
          
          textarea::-webkit-scrollbar-track {
            background: #c15d28;
            border-radius: 10px;
          }
          
          textarea::-webkit-scrollbar-thumb {
            background: #2f2d33;
            border-radius: 10px;
          }
          
          textarea::-webkit-scrollbar-thumb:hover {
            opacity: .8;
          }

          .p_photo-div {
            max-width: 200px;
          }

          .p_name {
            margin-top: 10px;
            font-size: 32px;
            font-weight: bold;
          }

          .profile-image {
            display:none;
          }
    
          .button {
            margin-top: 40px;
            width: 100px;
            height: 30px;
            border: 0;
            background: #212121;
            color: #fff;
          }

          .edit {
            height: max-content;
            padding: 7px;
            z-index: 1;
            border-radius: 30px;
            background: #212121;
            color: #fff;
            outline: none;
            display: flex;
            cursor: pointer;
            transition: .2s;
          }

          .edit:hover {
            background: #5b5b5c;
          }

          .card img {
            width: 150px;
            height: 150px;
            border-radius: 50%;
            object-fit: cover;
          }

          .profile-image {
            color: blue;
            border: 0;
          }

          label {
            color: blue;
            cursor: pointer;
            font-size: 15px;
          }

          .asdfasdf {
            justify-content:center;
            align-items: center;
          }

          footer {
            margin: 0;
          }

          @media (max-width: 900px) and (min-width: 623px) {
            .main {
              margin-top: 0px;
            }

            .banner {
              height: 150px;
              display: block;
            }
          }
          
          @media (max-width: 623px) {
            html {
              background: #F57029;
            }

            .banner {
              height: 150px;
              display: block;
            }

            .card {
              width: 100%;
              display: block;
              text-align: center;
            }

            .card-image {
              width: 280px;
              margin-top: -120px;
              border: 8px solid #f57029;
            }

            .card-image-c {
              width: 100%;
              margin-top: -158px;
            }
            
            .card-text {
              max-width: 85%;
            }

            .p_photo-div {
              margin: auto;
            }

            .p_name {
              text-align: center;
              padding-left: 0;
              text-align: center;
              padding-left: 0;
              background: rgba(0, 0, 0, .1);
              border-radius: 10px;
            }

            textarea {
              max-width: 85%;
              height: 30vh;
              margin-top: 15px;
              padding: 10px;
              font-size: 16px;
              background: rgba(0, 0, 0, .1);
              border-radius: 10px;
            }

            .edit {
              right: 8px;
              bottom: 62px;
              position: fixed;
            }

            .main {
              margin-top: 0px;
              padding: 0px 0px;
              box-shadow: 0 0 0;
            }
          }
        `}</style>
      </>
    );
}};

export default Profile;
//<div style={{ marginTop: 10 }}><input id="p_eposta" type="email" placeholder="E-Posta" disabled/></div>